import { apiClient } from './authService';

// Bons de commande fournisseur (réapprovisionnement) — /api/commandes/
const commandeService = {
  // Products at/below stock_min with per-supplier price comparison.
  getACommander: async () => {
    const response = await apiClient.get('commandes/a-commander/');
    return response.data; // { count, products: [...] }
  },

  // Price comparison for one product (manual add on the À commander page).
  getComparison: async (productId) => {
    const response = await apiClient.get(`commandes/comparison/${productId}/`);
    return response.data;
  },

  getAllOrders: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.supplier_id) params.append('supplier_id', filters.supplier_id);
    params.append('page_size', filters.page_size || 5000);
    const response = await apiClient.get(`commandes/orders/?${params.toString()}`);
    return Array.isArray(response.data) ? response.data : (response.data.results || []);
  },

  getOrderById: async (id) => {
    const response = await apiClient.get(`commandes/orders/${id}/`);
    return response.data;
  },

  // orders: [{ supplier, notes, items: [{ product, quantity, expected_cost }] }]
  bulkCreate: async (orders) => {
    const response = await apiClient.post('commandes/orders/bulk_create/', { orders });
    return response.data; // { created: [...] }
  },

  createOrder: async (order) => {
    const response = await apiClient.post('commandes/orders/', order);
    return response.data;
  },

  // data: { notes?, items? } — full items replacement while editable.
  updateOrder: async (id, data) => {
    const response = await apiClient.put(`commandes/orders/${id}/`, data);
    return response.data;
  },

  markSent: async (id, data = {}) => {
    const response = await apiClient.post(`commandes/orders/${id}/mark_sent/`, data);
    return response.data;
  },

  // receivedNote : note libre du « Reçu sans facture » (n° de facture
  // papier, remarque…) — affichée dans la liste des bons reçus.
  markReceived: async (id, factureId = null, receivedNote = '') => {
    const payload = {};
    if (factureId) payload.facture_id = factureId;
    if (receivedNote) payload.received_note = receivedNote;
    const response = await apiClient.post(
      `commandes/orders/${id}/mark_received/`, payload
    );
    return response.data;
  },

  cancelOrder: async (id) => {
    const response = await apiClient.post(`commandes/orders/${id}/cancel/`);
    return response.data;
  },

  deleteOrder: async (id) => {
    const response = await apiClient.delete(`commandes/orders/${id}/`);
    return response.data;
  },
};

export default commandeService;
